import { spawn } from 'utils/translations';
import { z } from 'zod';
import { CONNECT_FIELDS } from './consts';
import { validateConnectUrl } from './utils';

/**
 * Connect form schema. The GitLab URL runs the shared structural validation
 * (`validateConnectUrl`) with reason-specific messages; the access token is
 * required (the BE validates the token itself at connect).
 * @returns The Zod schema for the Connect step form.
 */
export const getConnectFormSchema = () => {
  const spawnValidation = spawn(
    'dialogs.gitlab-installation-v2.steps.connect.validation',
  );

  return z.object({
    [CONNECT_FIELDS.GITLAB_URL]: z.string().check((ctx) => {
      const result = validateConnectUrl(ctx.value);

      if (!result.isValid) {
        ctx.issues.push({
          code: 'custom',
          message: spawnValidation(result.error),
          input: ctx.value,
          path: [],
        });
      }
    }),
    [CONNECT_FIELDS.ACCESS_TOKEN]: z
      .string()
      .trim()
      .min(1, spawnValidation('token-required')),
  });
};
